function init_springevent(from_php){
    var main=$(".place.springevent");
    var girl_id=1,girl_img=$.takeGirlImage(girl_id);
    var anim_conf=$.takeGirlConf(girl_id,"fight_png");
    var conf={};
    var winHint=main.find("#hintWin");
    var i,showAnim=0;
    var haveAnims=[],confAnim;
    var anim_conf_all={
        "1":{"1":{"path":_IMG_SERV+"/gfx/place/springevent/animation/1/anim.png","conf":{width: 240, height: 697, clips: 16}}},
        "2":{"1":{"path":_IMG_SERV+"/gfx/place/springevent/animation/2/anim.png","conf":{width: 260, height: 613, clips: 13}}},
        "3":{"1":{"path":_IMG_SERV+"/gfx/place/springevent/animation/3/anim.png","conf":{width: 356, height: 456, clips: 16}}},
        "4":{"1":{"path":_IMG_SERV+"/gfx/place/springevent/animation/4/anim.png","conf":{width: 690, height: 871, clips: 18}}},
        "5":{
            "1":{"path":_IMG_SERV+"/gfx/place/springevent/animation/5/1/anim.png","conf":{width: 405, height: 521, clips: 11}},
            "2":{"path":_IMG_SERV+"/gfx/place/springevent/animation/5/2/anim.png","conf":{width: 405, height: 521, clips: 12}},
            "end":{"path":_IMG_SERV+"/gfx/place/springevent/animation/5/end/anim.png","conf":{width: 405, height: 521, clips: 21}},
            "after":{"path":_IMG_SERV+"/gfx/place/springevent/animation/5/after/anim.png","conf":{width: 405, height: 521, clips: 23}}
        }
    };
    var anim_id_last=0;
    var block_click=0;
    var animIndexAll={},animIndexQueue=_moduleTimeHandler.getNewIndex(),animIndexFade=_moduleTimeHandler;
    if(typeof from_php.showScene !== "undefined") {
        showAnim=Math.max(0,from_php.showScene-1);
    }

    function init(){
        //img_arr
        //level_user
        var i,bum,img_id;
        for(i in from_php.img_arr){
            bum=from_php.img_arr[i];
            img_id=bum.img_id;
            if(img_id==6){
                img_id="end";
            }
            if(bum.level<from_php.level_user){
                haveAnims.push(img_id);
            }
        }
        confAnim=from_php.img_arr;
        confAnim["end"]=confAnim["6"];

        var key;
        for(key in anim_conf_all){
            animIndexAll[key]=_moduleTimeHandler.getNewIndex();
        }
        animIndexAll["end"]=_moduleTimeHandler.getNewIndex();


        main.find(".animJS").each(function(){
            var th=$(this),anim_id=th.attr("data-anim");
            if(!in_array(anim_id,haveAnims)){
                th.addClass("unable");
            }
        });
        main.find(".eye").each(function(){
            $(this).myEye();
        });
    }
    init();


    for(i in anim_conf){
        conf[i]={"path":_IMG_SERV+"/gfx/place/fight/animation/"+girl_img+"/"+i+"/anim.png","conf":anim_conf[i]};
    }
    function addCumshot(){
        var qcanv=main.find(".canvWrap[data-anim='5'] .canvMain");
        _moduleTimeHandler.clear(animIndexAll["5"]);
        qcanv.animCircle("setSteps",[{howlong:1000,"end_val":0},{howlong:-1,"end_val":"end"}]);
        qcanv.off("beforeEnd.sp").one('beforeEnd.sp',function(){
            qcanv.animCircle("setTypeAva",["after"]);

            qcanv.animCircle("addSteps",[{howlong:5000,"end_val":0}]);
            _moduleTimeHandler.set(animIndexAll["end"],function(){
                if(qcanv.animCircle("howlongRemain")<5000){
                    qcanv.animCircle("addSteps",[{howlong:4000,"end_val":0}]);
                    qcanv.closest(".canvWrap").find(".eye").css("opacity",1);
                }
            },3000);
            block_click=0;
            anim_id_last="end";
        });
    }
    function prepareHint(anim_id){
        winHint.attr("data-anim",anim_id).show();
        winHint.find(".textfill").textfill();
        var num=confAnim[anim_id].level+1-from_php.level_user;
        winHint.find("#needValJS").html(num);
    }
    main.find(".animJS").click(function(){
        var th=$(this);
        var anim_id=th.attr("data-anim");
        if(!in_array(anim_id,haveAnims)){
            prepareHint(anim_id);
            return false;
        }
        else{
            winHint.hide();
        }
        var canvas_id=anim_id;
        if(canvas_id=="end"){
            canvas_id="5";
        }
        if(block_click){
            return false;
        }
        if(anim_id==anim_id_last && anim_id!="end"){
            return false;
        }
        block_click=1;
        var add_end=0;

        _moduleTimeHandler.clear(animIndexAll["end"]);

        if(anim_id_last=="5" && anim_id=="end"){
            //just add cumshot
            addCumshot();
            return true;

        }
        else if(anim_id=="end"){
            add_end=1;
            anim_id="5";
        }

        var qcanv=main.find(".canvWrap[data-anim='"+anim_id+"'] .canvMain");
        var qcanv_wrap=qcanv.closest(".canvWrap");

        qcanv.off("was_loaded").one("was_loaded",function(){
            var howlong_fadeout=1000,howlong_fadein=1000;
            if(anim_id_last){
                //hideOldAnim
                _moduleTimeHandler.queueAdd(animIndexQueue,function(){
                    var useId=anim_id_last;
                    if(useId=="end"){
                        useId="5";
                    }
                    var qcanv_last=main.find(".canvWrap[data-anim='"+useId+"'] .canvMain");
                    var qcanv_last_wrap=qcanv_last.closest(".canvWrap");
                    qcanv_last_wrap.animate({opacity:0},howlong_fadeout);
                    _moduleTimeHandler.setOne(animIndexFade,function(){

                        _moduleTimeHandler.clear(animIndexAll[anim_id_last]);
                        qcanv_last_wrap.hide();
                        if(anim_id==5 && anim_id_last=="end"){
                            qcanv_last.animCircle("clear");
                        }
                        else{
                            qcanv_last.animCircle("remove");
                        }
                        _moduleTimeHandler.queueTrigger(animIndexQueue);

                    },howlong_fadeout);
                });
            }
            //showNewAnim


            _moduleTimeHandler.queueAdd(animIndexQueue,function(){
                qcanv.animCircle("addSteps",[{howlong:4000,"end_val":0}]);
                _moduleTimeHandler.set(animIndexAll[anim_id],function(){
                    if(qcanv.animCircle("howlongRemain")<5000){
                        qcanv.animCircle("addSteps",[{howlong:4000,"end_val":0}]);
                    }
                },3000);



                if(anim_id==5 || anim_id=="end"){
                    qcanv.animCircle("setTypeAva",["1","2"]);
                }
                var speed_arr=[35,75];
                if(anim_id==2){
                    speed_arr=[150,200];
                }
                qcanv.animCircle("setClipsTime",speed_arr);
                qcanv.animCircle("start");

                _moduleTimeHandler.queueTrigger(animIndexQueue);
            });

            _moduleTimeHandler.queueAdd(animIndexQueue,function(){
                qcanv_wrap.css("opacity",0).show();
                qcanv_wrap.find(".eye").css("opacity",0);
                qcanv_wrap.animate({opacity:1},howlong_fadein);
                _moduleTimeHandler.setOne(animIndexFade,function(){
                    _moduleTimeHandler.queueTrigger(animIndexQueue);
                },howlong_fadein);
            });
            _moduleTimeHandler.queueAdd(animIndexQueue,function(){
                anim_id_last=anim_id;
                block_click=0;
                _moduleTimeHandler.queueTrigger(animIndexQueue);
            });
            if(add_end){
                _moduleTimeHandler.queueAdd(animIndexQueue,function(){
                    _moduleTimeHandler.setOne(animIndexAll["end"],function(){
                        addCumshot();
                    },500);
                });
            }

            _moduleTimeHandler.queueTrigger(animIndexQueue);




        }).animCircle({},anim_conf_all[anim_id],_moduleTimeHandler);
        if(anim_id=="5" && anim_id_last=="end"){
            qcanv.trigger("was_loaded");
        }

        main.find(".animJS").removeClass("active").filter("[data-anim='"+canvas_id+"']").addClass("active");


    }).eq(showAnim).trigger("click");



    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px");
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });


//
//    var qcanv=main.find(".canvMain[data-anim='5']").show();
//    qcanv.off("was_loaded").one("was_loaded",function(){
//        qcanv.animCircle("setTypeAva",["1","2"]);
//        qcanv.animCircle("addSteps",[{howlong:2000,"end_val":0},{howlong:2000,"end_val":1}]);
//        qcanv.animCircle("start");
//        _moduleTimeHandler.addOne(function(){
//            $.qLog("stop");
//            qcanv.animCircle("clear");
//            _moduleTimeHandler.addOne(function(){
//                $.qLog("start");
//                qcanv.animCircle("addSteps",[{howlong:2000,"end_val":0},{howlong:2000,"end_val":1}]);
//                qcanv.animCircle("start");
//
//            },1500);
//
//        },1500);
//
//    }).animCircle({},anim_conf_all["5"],_moduleTimeHandler);

}
